export * from './components/dynamic-form.component';
export * from './components/dynamic-form-question.component';
export * from './components/question-control.service';
export * from './mcs';
export * from './ois';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
